import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContratService } from '../../shared/client/contrat/contrat.service';
import { LigneContrat } from '../../shared/client/contrat/ligne-contrat';
import { MatTableDataSource } from '@angular/material/table';
import { SideBarComponent } from '../../shared/sidebar/side-bar-component';
import { SideBarService } from '../../shared/sidebar/side-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticleGenerique } from '../../delivery/shared/article-generique/article-generique';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lp',
  templateUrl: './lp.component.html',
  styleUrls: ['./lp.component.scss']
})
export class LPComponent extends SideBarComponent implements OnInit, OnDestroy {

  lockOther: boolean = false;
  sub: Subscription = new Subscription();

  displayedColumns: Array<string> = [
    'code_article',
    'designation',
    'qte_stock',
    'action'
  ];
  lignesContrat: MatTableDataSource<LigneContrat> = new MatTableDataSource<LigneContrat>();
  load: boolean = true;

  constructor(
    protected sideBar: SideBarService,
    protected router: Router,
    protected route: ActivatedRoute,
    private contratService: ContratService
  ) {
    super(sideBar, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadLignesContrat();
  }

  private loadLignesContrat() {
    this.sub = this.contratService.getLignesContratLP().subscribe(lignes => { this.lignesContrat.data = lignes; this.load = false; });
  }

  stockEnable($event: boolean) {
    this.lockOther = $event;
  }

  editStock(article: ArticleGenerique) {
    this.router.navigate([{
      outlets: {
        sidebar: [article.code_article, 'edit-stock']
      }
    }], {
        relativeTo: this.route,
        skipLocationChange: true
      }).then(() => this.sideBar.open(), error => console.log(error));
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

}
